import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Input,
    Label,
    FormGroup, CustomInput,
    Table
} from "reactstrap"
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import { FileInput, generateFormData } from '../../../../helpers/ui/FileInput'
import { AvForm, AvGroup, AvInput, AvField, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"
import Select from "react-select"
import moment from 'moment'

import { Link, useHistory, Redirect } from "react-router-dom"
import { withRouter } from "react-router";

import apiResponse from '../../../../services/apiResponse'
import Shimmer from "react-shimmer-effect";
import CustomSelect from "../../../../helpers/ui/CustomSelect"

import UpdateBloc from './Blocs/UpdateBloc'

class IndexView extends Component {

    updateBloc = new UpdateBloc();

    constructor(props) {
        super(props)
        this.state = {
            dataForm: {},
            totalRow : null,
            punishmentOptions: []
        }
    }

    handleChecked = (e, index, val) => {
        var checked = e.target.checked;

        if (checked) {
            this.setState({
                [`timeRevision${index}`] : val
            })
        } else {
            this.setState({
                [`timeRevision${index}`] : ""
            })
        }
        
        console.log(index, checked);
    }

    dateParse = (input) =>{
        let res = "-";
        if (input != "" && input != null){
          res = moment(input).format('DD/MM/YYYY')
        }
        return res;
    }

    reformatOptions = function(raw, label, value) {
        return raw.map(function(data) {
          var newObj = {};
          newObj["label"] = data[label];
          newObj["value"] = data[value];
      
          return newObj;
        });
    };

    submitData = async () => {
        const formData = generateFormData(this.state.dataForm, ['file_lhp', 'file_bap']) // Jika nama field fileinputnya adalah 'File', maka parameter kedua boleh dikosongkan. Jika ada lebih dari 1 file input, maka gunakan array. conth: ['document', 'foto'] 
        await this.updateBloc.fetchUpdate(formData)
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: {
                uuid: this.state.detail?.punishment_discipline_uuid,
                ...values
            },
            confirm: true
        })
        console.log(values)
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    componentDidMount() {
        this.updateBloc.updateChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

        // this.updateBloc.detailChannel.subscribe((result) => {
        //     switch (result.status) {
        //         case apiResponse.COMPLETED:
        //             if(result.data.status) {
        //                 let response = result.data.response
        //                 //console.log(response)
        //                 let detailDiscipline = response.details;
        //                 this.setState({
        //                     detail: response,
        //                     detailDiscipline: detailDiscipline
        //                 })

        //                  // set state for every checkbox
        //                 if (detailDiscipline.length > 0) {
        //                     for (let i = 0; i < detailDiscipline.length; i++) {
        //                         // let thisId = detailDiscipline[i].punishment_discipline_detail_id
        //                         this.setState({
        //                             [`check${i}`] : false,
        //                             [`timeRevision${i}`] : "",
        //                         })
        //                     }
        //                 }
        //             }
        //             break
        //         case apiResponse.ERROR:
                    
        //             break
        //         default:
        //             break
        //     }
        // })

        // this.updateBloc.punishmentChannel.subscribe((result) => {
        //     switch (result.status) {
        //         case apiResponse.COMPLETED:
        //             if(result.data.status) {
        //                 let response = result.data.response
        //                 //console.log(response)
                        
        //                 this.setState({
        //                     punishmentOptions: this.reformatOptions(
        //                         response.result, 
        //                         'punishment_name',
        //                         'punishment_uuid'
        //                     )
        //                 })
        //             }
        //             break
        //         case apiResponse.ERROR:
                    
        //             break
        //         default:
        //             break
        //     }
        // })
        // this.updateBloc.fetchPunishment({is_tunkin: 1})

        // const queryParams = new URLSearchParams(this.props.location.search)
        // this.updateBloc.fetchDetail({uuid: queryParams.get('uuid') })
    }

    componentWillUnmount() {
        this.updateBloc.updateChannel?.unsubscribe()
        this.updateBloc.detailChannel?.unsubscribe()
    }

    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">

                            <Card>
                                <CardBody>
                                    <CardTitle>Input Hasil Pemeriksaan</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        Setiap isian yang bertanda (<span className="text-danger">*</span>) adalah wajib diisi.
                                    </CardSubtitle>
                                    <hr />
                                    <AvForm
                                        className="needs-validation"
                                        onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                                    >
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                # Pegawai Terkena Hukuman
                                            </label>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                NIP
                                            </label>
                                            <Col md="9">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.punishment_discipline_employee_nip !== "" ? this.state.detail.punishment_discipline_employee_nip : '-'}</>
                                                    : <Shimmer><div style={{width: '30%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Nama
                                            </label>
                                            <Col md="9">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.punishment_discipline_employee_name !== "" ? this.state.detail.punishment_discipline_employee_name : '-'}</>
                                                    : <Shimmer><div style={{width: '30%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Pangkat
                                            </label>
                                            <Col md="9">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.punishment_discipline_employee_rank !== "" ? this.state.detail.punishment_discipline_employee_rank : '-'}</>
                                                    : <Shimmer><div style={{width: '30%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Jabatan
                                            </label>
                                            <Col md="9">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.punishment_discipline_employee_position !== "" ? this.state.detail.punishment_discipline_employee_position : '-'}</>
                                                    : <Shimmer><div style={{width: '30%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Unit Kerja
                                            </label>
                                            <Col md="9">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.punishment_discipline_employee_work_unit !== "" ? this.state.detail.punishment_discipline_employee_work_unit : '-'}</>
                                                    : <Shimmer><div style={{width: '30%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                        </Row>

                                        <hr />

                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                # Atasan langsung
                                            </label>
                                        </Row>

                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                NIP
                                            </label>
                                            <Col md="9">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.punishment_discipline_head_employee_nip !== "" ? this.state.detail.punishment_discipline_head_employee_nip : '-'}</>
                                                    : <Shimmer><div style={{width: '30%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Nama
                                            </label>
                                            <Col md="9">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.punishment_discipline_head_employee_name !== "" ? this.state.detail.punishment_discipline_head_employee_name : '-'}</>
                                                    : <Shimmer><div style={{width: '30%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Pangkat
                                            </label>
                                            <Col md="9">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.punishment_discipline_head_employee_rank !== "" ? this.state.detail.punishment_discipline_head_employee_rank : '-'}</>
                                                    : <Shimmer><div style={{width: '30%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Jabatan
                                            </label>
                                            <Col md="9">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.punishment_discipline_head_employee_position !== "" ? this.state.detail.punishment_discipline_head_employee_position : '-'}</>
                                                    : <Shimmer><div style={{width: '30%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                        </Row>

                                        <hr />

                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Amnesti
                                            </label>
                                            <Col md="9">
                                                {
                                                    this.state.detailDiscipline ? 
                                                        <div>
                                                             <table className="table table-bordered table-striped">
                                                                <thead>
                                                                    <tr>
                                                                        <th>Tanggal</th>
                                                                        <th>Jumlah Jam</th>
                                                                        <th className="text-center" colSpan="2">Amnesti</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        this.state.detailDiscipline.length > 0 ?
                                                                            this.state.detailDiscipline.map((data, index) => {
                                                                                return (
                                                                                    <tr>
                                                                                        <td>{this.dateParse(data.punishment_discipline_detail_presensi_date)}</td>
                                                                                        <td>{data.punishment_discipline_detail_presensi_time}</td>
                                                                                        <td>
                                                                                            <AvField
                                                                                                name={`punishment_discipline_detail_uuid[${index}]`}
                                                                                                type="hidden"
                                                                                                value={data.punishment_discipline_detail_uuid}
                                                                                            />
                                                                                            {/* <AvField
                                                                                                name={`punishment_discipline_detail_presensi_time_revision[${index}]`}
                                                                                                placeholder="Koreksi Jam..."
                                                                                                type="time"
                                                                                                step={1}
                                                                                                errorMessage="Masukkan Koreksi Jam"
                                                                                                className="form-control"
                                                                                                // validate={{ required: { value: true } }}
                                                                                                id="punishment_discipline_detail_presensi_time_revision"
                                                                                                // value={data.working_hours_start}
                                                                                            /> */}
                                                                                            <Input 
                                                                                                className="form-control"
                                                                                                name={`punishment_discipline_detail_presensi_time_revision_i[${index}]`}
                                                                                                placeholder="Koreksi Jam..."
                                                                                                type="time"
                                                                                                step={1}
                                                                                                id="punishment_discipline_detail_presensi_time_revision"
                                                                                                value={this.state[`timeRevision${index}`]}
                                                                                            />
                                                                                            <AvField
                                                                                                name={`punishment_discipline_detail_presensi_time_revision[${index}]`}
                                                                                                type="hidden"
                                                                                                value={this.state[`timeRevision${index}`]}
                                                                                            />
                                                                                        </td>
                                                                                        <td>
                                                                                            <div className="form-check text-center font-size-16">
                                                                                                <Input 
                                                                                                    type="checkbox" 
                                                                                                    className="form-check-input" 
                                                                                                    id={'checkbox' + index }
                                                                                                    onChange={
                                                                                                    (event)=>{
                                                                                                        this.handleChecked(event, index, data.punishment_discipline_detail_presensi_time);
                                                                                                        this.setState({
                                                                                                            [`check${index}`] : !this.state[`check${index}`]
                                                                                                        })
                                                                                                    }
                                                                                                    }
                                                                                                    checked={this.state[`check${index}`]}
                                                                                                />
                                                                                            </div>
                                                                                        </td>
                                                                                    </tr>
                                                                                );
                                                                            })
                                                                        : 
                                                                        <tr>
                                                                            <td colSpan="3" className="text-center">Tidak Ada Data</td>
                                                                        </tr>
                                                                    }
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    : <Shimmer><div style={{width: '100%', height: 35}}></div></Shimmer>
                                                }
                                            </Col>
                                        </Row>

                                        <hr />

                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Keputusan Hukuman Berdasarkan Hasil Pemeriksaan <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <CustomSelect 
                                                    name="punishment_discipline_result_punishment_uuid"
                                                    errorMessage="Pilih Keputusan Hukuman"
                                                    options={this.state.punishmentOptions} 
                                                    placeholder="Pilih Keputusan Hukuman"
                                                    defaultValue={this.state.detail?.punishment_discipline_punishment_uuid}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Keterangan Hasil Pemeriksaan <span className="text-danger">*</span>
                                            </label>
                                            <Col md="8">
                                            <AvField
                                                    name="punishment_discipline_result_description"
                                                    placeholder="Keterangan Hasil Pemeriksaan"
                                                    errorMessage="Masukkan Keterangan Hasil Pemeriksaan"
                                                    type="textarea"
                                                    className="form-control"
                                                    // value={this.state.detail?.punishment_discipline_result_description}
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>

                                        <hr />

                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Upload Berita Acara Pemeriksaan <span className="text-danger">*</span>
                                            </label>
                                            <Col md="4">
                                                <FileInput
                                                    name="file_bap"
                                                    col="4"
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Upload Laporan Hasil Pemeriksaan <span className="text-danger">*</span>
                                            </label>
                                            <Col md="4">
                                                <FileInput
                                                    name="file_lhp"
                                                    col="4"
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <Col md="3"></Col>
                                            <Col md="9">
                                                <Link to="?">
                                                    <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                                </Link>
                                                {' '}
                                                <Button color="success" type="submit">
                                                    <i className="uil-arrow-up-right"></i> Simpan Data
                                                </Button>
                                            </Col>
                                        </Row>
                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menyimpan data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    <Redirect to='/kepegawaian/hukuman_disiplin.html?'/>
                : null }
            </Fragment>
        )
    }

}

//export default IndexView
export default withRouter(IndexView);